export default {
    props: ['name'],
    render() {
        let name = this.name || 'solid/ban'
        let icon = null
        try{
            icon = require(`@/assets/svgs/${name}.svg`)
        }catch (err) {
            icon =  require(`@/assets/svgs/solid/ban.svg`)
        }
        let div = document.createElement('div');
        div.innerHTML = icon

        let fragment = document.createDocumentFragment();
        fragment.appendChild(div);

        let svg = fragment.querySelector('svg');

        let fr = document.createDocumentFragment();
        fr.appendChild(svg)

        let attr= {}
        for(let i = 0; i< svg.attributes.length; i++) {
            let x = svg.attributes[i];
            attr[[x.name]] = x.value
        }
        return <svg fill="currentColor" height="1em" domPropsInnerHTML={svg.innerHTML} {...{ attrs: attr }}></svg>
    }
};
